import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { NO_RECORDS_FOUND } from "../../../../../utils/constants";
import InfiniteScroll from "react-infinite-scroll-component";

const AddMedicine = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      if (page) {
        setMainRegisterData(prev => {
          return [...prev, ...props.tableData]
        })
      } else {
        tableRef.current.scrollTo(0, 0)
        setMainRegisterData(props.tableData)
      }
    }
  }, [props.tableData])

  const fetchData = () => {
    props.handleChangePage(page + 1);
    props.getTableData(true);
  }

  return (
    <>
      <InfiniteScroll
        dataLength={mainRegisterData?.length}
        next={fetchData}
        hasMore={mainRegisterData?.length !== totalSize}
        scrollableTarget="mul-dartaa-register"
      >
        <TableContainer classes={{ root: "fixed-head-table-container" }}>
          <Table
            classes={{ root: "table-bordered normal-spacing" }}
            size="small"
            aria-label="Add-Medicine"
          >
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell>S.N</TableCell>
                <TableCell>औषधि सूची</TableCell>
                <TableCell>फायल संख्या</TableCell>
                <TableCell>सम्पादन</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }} ref={tableRef}>
              {
                mainRegisterData?.length > 0 ? (
                  mainRegisterData?.map((row, index) => (
                    <TableRow key={row?.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row?.medicineName}</TableCell>
                      <TableCell>{row?.medicineUnit}</TableCell>
                      <TableCell align="center">
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          gap={1}
                        >
                          <Tooltip
                            title="औषधि विवरण सम्पादन गर्न यहा क्लिक गर्नुहोस"
                            placement="top"
                            arrow
                          >
                            <IconButton>
                              <Edit fontSize="small" color="primary" onClick={() => props.onEditRow(row?.id)} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title="औषधि विवरण हटाउन यहा क्लिक गर्नुहोस"
                            placement="top"
                            arrow
                          >
                            <IconButton>
                              <Delete fontSize="small" color="secondary" onClick={() => props.onDeleteRow(row?.id)} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="22" size="medium">{NO_RECORDS_FOUND}</TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>
    </>
  );
};

export default AddMedicine;